export default __webpack_public_path__ + "static/media/image19tum.f916177d.jpg";